export default class Collection {

	serialize = () => {
		var str = JSON.stringify(this);
		return str;
	}

	addData = (dataObj, obj) => {
		var retVal = [];
		for (let i = 0; i < dataObj.length; ++i) {
			var newObj = obj.createNewInstance();
			newObj.addData(dataObj[i]);
			retVal.push(newObj);
		}
		return retVal;
	}
	
	unserialize = (str) => {
		var serializedObject = JSON.parse(str);
		Object.assign(this, serializedObject);
		return this;
	}
	

}

